export default {
  highchart: {
    resetZoom: '重置缩放',
    noData: '暂无数据'
  }
}
